<ng-template cellTemplate let-dataItem="dataItem">
    <div class="cell"
         (click)="$event['ignoreClickOutside'] = true">
        <div class="cell-value" [ngClass]="{'empty': isEmpty(dataItem | property: field)}">{{isEmpty(dataItem | property: field) && showPlaceholderForCell ? (getPlaceholder(dataItem) | translate) : isEmpty(dataItem | property: field) ? '' : (dataItem | property: field | number : format)}}</div>
        <div class="cell-notation">{{(dataItem | property: field) == null && !showPlaceholderForCell ? '' : notation}}</div>
    </div>
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-columnIndex="columnIndex"
             let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [select]="true"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <fui-numeric-control #editControl [formControl]="formGroup.get(column.field)" [attr.id]="elementId"
                         [control]="formGroup.get(column.field)" [readOnly]="cellDisabled(formGroup, dataItem)"
                         (valueChange)="controlValueChange($event, dataItem, formGroup)"
                         (focussed$)="columnFocusHandler(columnIndex)"
                         [placeholder]="getPlaceholder(dataItem)"
                         [notation]="notation">
    </fui-numeric-control>
</ng-template>
